import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Transition } from '@headlessui/react';
import useDesktopNavItems from 'components/nav/shared/data/useDesktopNavItems';
import DesktopNavCategorySection from '../DesktopNavCategorySection';
const DesktopNavCategoryModal = t0 => {
  const $ = _c(33);
  const {
    categoryId: selectedCategoryId,
    isOpen,
    setIsSectionHovered
  } = t0;
  const categoryNavItems = useDesktopNavItems();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== categoryNavItems || $[1] !== isOpen || $[2] !== selectedCategoryId || $[3] !== setIsSectionHovered) {
    const categoryIds = categoryNavItems.map(_temp);
    const t7 = !isOpen;
    if ($[10] !== isOpen || $[11] !== t7) {
      t4 = classNames("bg-white w-full", {
        "pointer-events-auto": isOpen,
        "pointer-events-none": t7
      });
      $[10] = isOpen;
      $[11] = t7;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    if ($[13] !== setIsSectionHovered) {
      t5 = () => {
        setIsSectionHovered(true);
      };
      t6 = () => {
        setIsSectionHovered(false);
      };
      $[13] = setIsSectionHovered;
      $[14] = t5;
      $[15] = t6;
    } else {
      t5 = $[14];
      t6 = $[15];
    }
    t1 = "DesktopNavCategoryModal bg-white relative w-full";
    const t8 = !isOpen;
    let t9;
    if ($[16] !== isOpen || $[17] !== t8) {
      t9 = classNames("h-[300px] bg-white absolute left-0 top-0 right-0 min-h-[508px] pt-11 pointer-events-none duration-500 ease-in delay-100", {
        "!opacity-100 transition-none": isOpen,
        "opacity-0 transition-[opacity]": t8
      });
      $[16] = isOpen;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    if ($[19] !== t9) {
      t2 = <div className={t9} key="background" aria-hidden={true} />;
      $[19] = t9;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    let t10;
    if ($[21] !== isOpen || $[22] !== selectedCategoryId) {
      t10 = categoryId => <Transition key={categoryId} className={classNames({
        "pointer-events-none": !isOpen
      })} show={categoryId === selectedCategoryId && isOpen} enter="transition-opacity duration-200 ease-in" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-200 ease-in delay-200" leaveFrom="opacity-100" leaveTo="opacity-0"><DesktopNavCategorySection isOpen={categoryId === selectedCategoryId && isOpen} categoryId={categoryId} /></Transition>;
      $[21] = isOpen;
      $[22] = selectedCategoryId;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t3 = categoryIds.map(t10);
    $[0] = categoryNavItems;
    $[1] = isOpen;
    $[2] = selectedCategoryId;
    $[3] = setIsSectionHovered;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[24] !== t1 || $[25] !== t2 || $[26] !== t3) {
    t7 = <div className={t1}>{t2}{t3}</div>;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <div className={t4} onMouseEnter={t5} onMouseLeave={t6}>{t7}</div>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
};
DesktopNavCategoryModal.propTypes = {
  categoryId: PropTypes.string,
  isOpen: PropTypes.bool,
  setIsSectionHovered: PropTypes.func
};
export default DesktopNavCategoryModal;
function _temp(category) {
  return category.id;
}